import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { act } from "react-dom/test-utils";

export interface SalesDashboardState {
  aggregation: string;
  timeFrames: string;
  seller_id: string;
  isChart: boolean;
  dollars: boolean;
  units: boolean;
  goalsDollars: boolean;
  goalsUnits: boolean;
  lineChart: boolean;
}

export const initialState: SalesDashboardState = {
  aggregation: "month",
  timeFrames: "10",
  seller_id: "",
  isChart: true,
  dollars: true,
  units: false,
  goalsDollars: false,
  goalsUnits: false,
  lineChart: true,
};

export const salesDashboardSlice = createSlice({
  name: "salesDashboard",
  initialState,
  reducers: {
    changeAggregation: (
      state: SalesDashboardState,
      action: PayloadAction<string>
    ) => {
      state.aggregation = action.payload;
    },
    changeSellerId: (
      state: SalesDashboardState,
      action: PayloadAction<string>
    ) => {
      state.seller_id = action.payload;
    },
    changeTimeFrames: (
      state: SalesDashboardState,
      action: PayloadAction<string>
    ) => {
      state.timeFrames = action.payload;
    },
    toggleChart: (
      state: SalesDashboardState,
      action: PayloadAction<boolean>
    ) => {
      state.isChart = action.payload;
    },
    updateDollarChart: (
      state: SalesDashboardState,
      action: PayloadAction<boolean>
    ) => {
      state.dollars = action.payload;
    },
    updateUnitsChart: (
      state: SalesDashboardState,
      action: PayloadAction<boolean>
    ) => {
      state.units = action.payload;
    },
    updateGoals: (
      state: SalesDashboardState,
      action: PayloadAction<{ dollars: boolean; units: boolean }>
    ) => {
      state.goalsDollars = action.payload.dollars;
      state.goalsUnits = action.payload.units;
    },
    changeChartType: (
      state: SalesDashboardState,
      action: PayloadAction<boolean>
    ) => {
      state.lineChart = action.payload;
    },
  },
});

export const {
  changeAggregation,
  changeTimeFrames,
  toggleChart,
  updateDollarChart,
  updateUnitsChart,
  updateGoals,
  changeChartType,
} = salesDashboardSlice.actions;
